import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import "./AddMatch.css";

const defaultScoreOdds = [
  { score: "0 - 0", odds: 1.45 },
  { score: "1 - 0", odds: 4.85 },
  { score: "0 - 1", odds: 5.26 },
  { score: "1 - 1", odds: 1.87 },
  { score: "2 - 1", odds: 0.17 },
  { score: "1 - 2", odds: 3.08 },
  { score: "0 - 2", odds: 4.18 },
  { score: "2 - 0", odds: 2.25 },
  { score: "2 - 2", odds: 1.95 },
  { score: "0 - 3", odds: 2.92 },
  { score: "3 - 0", odds: 3.78 },
  { score: "3 - 3", odds: 1.10 },
  { score: "2 - 3", odds: 1.63 },
  { score: "3 - 2", odds: 1.05 },
  { score: "1 - 3", odds: 3.38 },
  { score: "3 - 1", odds: 2.43 },
];

// 🔹 Normalize team names
const normalizeTeam = (name) =>
  name.toLowerCase().replace(/\s+/g, "").trim();

const AddMatch = () => {
  const [matches, setMatches] = useState(
    Array(25)
      .fill()
      .map(() => ({
        teamA: "",
        teamB: "",
        date: "",
        time: "",
        dayOfWeek: "",
        success: "",
        scoreOdds: defaultScoreOdds.map((o) => ({ ...o })),
      }))
  );

  const [existingMatches, setExistingMatches] = useState({});
  const [globalMessage, setGlobalMessage] = useState("");

  const getDayOfWeek = (dateStr) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[new Date(dateStr).getDay()];
  };

  const handleChange = (index, field, value) => {
    const updated = [...matches];
    updated[index][field] = value;

    if (field === "date") {
      updated[index].dayOfWeek = getDayOfWeek(value);
    }

    setMatches(updated);

    if (field === "teamA" || field === "teamB") {
      checkExistingMatch(index, updated[index]);
    }
  };

  const handleScoreOddsChange = (matchIndex, scoreIndex, value) => {
    const updated = [...matches];
    updated[matchIndex].scoreOdds[scoreIndex].odds =
      parseFloat(value) || 0;
    setMatches(updated);
  };

  // 🔍 CHECK EXISTING MATCH (case-insensitive + reverse safe)
  const checkExistingMatch = async (index, match) => {
    if (!match.teamA || !match.teamB) return;

    const inputA = normalizeTeam(match.teamA);
    const inputB = normalizeTeam(match.teamB);

    const snapshot = await getDocs(collection(db, "matches"));
    let found = "";

    snapshot.forEach((docSnap) => {
      const data = docSnap.data();

      const dbA = normalizeTeam(data.teamA);
      const dbB = normalizeTeam(data.teamB);

      const sameOrder = inputA === dbA && inputB === dbB;
      const reverseOrder = inputA === dbB && inputB === dbA;

      const dateMatch = match.date
        ? data.matchDate === match.date
        : true;

      if ((sameOrder || reverseOrder) && dateMatch) {
        found = `⚠️ Mechi hii tayari ipo: ${data.teamA} vs ${data.teamB} (${data.matchDate} ${data.matchTime})`;
      }
    });

    setExistingMatches((prev) => ({
      ...prev,
      [index]: found,
    }));
  };

  const handleSubmitAll = async () => {
    let saved = 0;
    const updated = [...matches];

    for (let i = 0; i < matches.length; i++) {
      const m = matches[i];

      if (!m.teamA || !m.teamB || !m.date || !m.time) {
        updated[i].success = "Tafadhali jaza sehemu zote!";
        continue;
      }

      const q = query(
        collection(db, "matches"),
        where("matchDate", "==", m.date),
        where("matchTime", "==", m.time)
      );

      const snap = await getDocs(q);
      let duplicate = false;

      snap.forEach((docSnap) => {
        const d = docSnap.data();
        const a1 = normalizeTeam(d.teamA);
        const b1 = normalizeTeam(d.teamB);
        const a2 = normalizeTeam(m.teamA);
        const b2 = normalizeTeam(m.teamB);

        if (
          (a1 === a2 && b1 === b2) ||
          (a1 === b2 && b1 === a2)
        ) {
          duplicate = true;
        }
      });

      if (duplicate) {
        updated[i].success = "Mechi tayari ipo!";
        continue;
      }

      await addDoc(collection(db, "matches"), {
        teamA: m.teamA,
        teamB: m.teamB,
        matchDate: m.date,
        matchTime: m.time,
        dayOfWeek: m.dayOfWeek,
        scoreOdds: m.scoreOdds,
      });

      updated[i].success = "Imehifadhiwa!";
      saved++;
    }

    setMatches(updated);
    setGlobalMessage(`${saved} mechi zimehifadhiwa kikamilifu`);
  };

  return (
    <div className="add-match-container">
      <h2>Ongeza Mechi Mpya</h2>

      {matches.map((match, index) => (
        <div key={index} className="match-block">
          <h4>Mechi {index + 1}</h4>

          <input
            placeholder="Timu A"
            value={match.teamA}
            onChange={(e) =>
              handleChange(index, "teamA", e.target.value)
            }
          />

          <input
            placeholder="Timu B"
            value={match.teamB}
            onChange={(e) =>
              handleChange(index, "teamB", e.target.value)
            }
          />

          <input
            type="date"
            value={match.date}
            onChange={(e) =>
              handleChange(index, "date", e.target.value)
            }
          />

          <input
            type="time"
            value={match.time}
            onChange={(e) =>
              handleChange(index, "time", e.target.value)
            }
          />

          {existingMatches[index] && (
            <p style={{ color: "orange", fontWeight: "bold" }}>
              {existingMatches[index]}
            </p>
          )}

          <h5>Odds</h5>
          {match.scoreOdds.map((s, i) => (
            <div key={i}>
              <span>{s.score}</span>
              <input
                type="number"
                value={s.odds}
                onChange={(e) =>
                  handleScoreOddsChange(index, i, e.target.value)
                }
              />
            </div>
          ))}

          {match.success && <p>{match.success}</p>}
        </div>
      ))}

      <button onClick={handleSubmitAll}>
        Hifadhi Mechi
      </button>

      {globalMessage && <p>{globalMessage}</p>}
    </div>
  );
};

export default AddMatch;